<template>
  <div class="swiper__item">
      <div class="swiper__text">{{text}}</div>
      <div class="swiper__author-info">
        <div class="swiper__author">{{author}}</div>
        <div class="swiper__author-desc">{{authorDesc}}</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'LandingFeedbackHolder',
  props: ['text', 'author', 'authorDesc']
}
</script>
